// SPA-side deployment config adoption.
//
// The server injects `window.__AUTH_CONFIG__` into the served index.html
// (src/login/spa-index.ts). We merge it over the compiled-in TwoShot
// defaults — so a page served without injection (old server, direct file
// open, Vite dev) renders TwoShot exactly as before, and an injected partial
// from an older/newer server never leaves fields undefined.
//
// Must run BEFORE first render: main.tsx calls adoptInjectedDeployment() in
// its module body, and components read activeDeployment() at render time
// (never at module scope) so they always see the adopted config.
import {
    activeDeployment,
    mergeDeploymentConfig,
    setActiveDeployment,
    TWOSHOT_DEPLOYMENT,
    type AuthDeploymentConfig,
} from "../../shared/deployment-config.ts";

declare global {
    interface Window {
        __AUTH_CONFIG__?: Partial<AuthDeploymentConfig>;
    }
}

export function adoptInjectedDeployment(): AuthDeploymentConfig {
    const injected = typeof window !== "undefined" ? window.__AUTH_CONFIG__ : undefined;
    const cfg = injected ? mergeDeploymentConfig(TWOSHOT_DEPLOYMENT, injected) : TWOSHOT_DEPLOYMENT;
    setActiveDeployment(cfg);
    return cfg;
}

/** Render-time accessor for components. */
export function deploymentConfig(): AuthDeploymentConfig {
    return activeDeployment();
}
